import React, { useEffect } from "react";
import { Card } from "antd";
import flow from "../../assets/images/flow.png";
import TstChart from "../tst/TstChart";
import SaleOrderList from "./SaleOrderList";
import { useModel } from "../../models";
import { useHistory } from "react-router";
import "./Home.less"
import { goPage } from "../layout/pageDefinition";

export default function () {
    const history = useHistory();

    /*useEffect(() => {
        (async () => {
            let dicts = await CmDictService.getCustomerTypeDict();
            console.log(dicts);
            dicts = await CmDictService.getSupplierTypeDict();
            console.log(dicts);
        })();
    }, [])*/
    useEffect(() => {
    }, [])
    const Title = () => {
        return (<div style={{ display: "flex", justifyContent: "space-between" }}>
            <h3>销售待办</h3>
            <h3 className="textRight" onClick={() => { goPage(history, "3-2") }}>更多</h3>
        </div>)
    }
    return <div style={{ display: "flex", overflowX: "auto" }}>
        <Card
            title={<h3>业务流程图</h3>}
            bordered={true}
            className="margin-top-8"
            style={{ width: "600px" }}
        >
            <p style={{ textAlign: "center" }}>
                <img src={flow} style={{ width: "550px" }} />
            </p>
        </Card>
        <div className=" margin-left-8" style={{ flex: 1 }}>
            <Card
                title={<Title></Title>}
                bordered={true}
                className="margin-top-8"
                style={{ height: "350px", minWidth: "400px" }}
            >
                <SaleOrderList />
            </Card>
            <Card className="margin-top-8" title={<h3>统计图标</h3>} bordered={true}>
                <TstChart width="890px" height="400px" />
            </Card>

        </div>
    </div>
};